(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gwa-warranty"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gwa-warranty')) {
    customElements.define('gwa-warranty', class extends HTMLElement {
      connectedCallback() {
        if (this.warrantyReady) return;
        this.warrantyReady = true;
        const dialog = this.querySelector('dialog');
        const trigger = this.querySelector('[data-warranty-open]');
        if (!dialog || typeof dialog.showModal !== 'function') return;
        trigger.addEventListener('click', event => {
          event.preventDefault();
          dialog.showModal();
        });
        this.querySelector('[data-warranty-close]').addEventListener('click', () => dialog.close());
        const zoom = this.querySelector('[data-warranty-zoom]');
        zoom.addEventListener('click', () => {
          const expanded = zoom.getAttribute('aria-pressed') !== 'true';
          zoom.setAttribute('aria-pressed', String(expanded));
          this.querySelector('.gwa-warranty__body').classList.toggle('is-zoomed', expanded);
        });
        dialog.addEventListener('click', event => {
          const bounds = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
        });
        dialog.addEventListener('close', () => trigger.focus({ preventScroll: true }));
      }
      disconnectedCallback() {
        const dialog = this.querySelector('dialog');
        if (dialog && dialog.open) dialog.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
